import { combineReducers } from 'redux';
import common from './common';
import notificationsList from './notificationsList';
import editNotification from './editNotification';
import ui from './ui';
import audiences from './audiences';
import usersPermissions from './usersPermissions';

const createRootReducer = () =>
    combineReducers({
        common,
        notifications: notificationsList,
        edit: editNotification,
        ui,
        audiences,
        usersPermissions
    });

export default createRootReducer;
